import React, { useState } from 'react';
import { Form, Input, Button, message, Modal, Checkbox } from 'antd';
import axios from 'axios';
import { apiUrl } from './config';
import { normalizzaEmail, suggerisciCorrezione, erroreBloccante } from '../utils/email';

const RegisterUser = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    // Suggerimento quando il dominio somiglia a uno noto ma non lo e'.
    const [correzione, setCorrezione] = useState(null);
    const [emailConfermata, setEmailConfermata] = useState(null);

    const onFinish = async (values) => {
        const email = normalizzaEmail(values.email);

        const errore = erroreBloccante(email);
        if (errore) {
            message.error(errore);
            return;
        }

        // La password temporanea arriva per email: se l'indirizzo e' sbagliato
        // l'utente viene creato ma non ricevera' mai nulla.
        const proposta = suggerisciCorrezione(email);
        if (proposta && email !== emailConfermata) {
            setCorrezione(proposta);
            return;
        }

        setLoading(true);
        try {
            // L'assegnazione al trainer la fa il server, dal token.
            await axios.post(`${apiUrl}/api/auth/register-user`, {
                ...values,
                email,
                privacyAccepted: true,
            });
            message.success('Utente registrato con successo. È stata inviata una password temporanea.');
            form.resetFields();
            setEmailConfermata(null);
        } catch (error) {
            message.error(error.response?.data?.error || 'Errore durante la registrazione dell\'utente.');
        } finally {
            setLoading(false);
        }
    };

    const accettaCorrezione = () => {
        form.setFieldsValue({ email: correzione });
        setEmailConfermata(correzione);
        setCorrezione(null);
        form.submit();
    };

    const mantieniIndirizzo = () => {
        setEmailConfermata(normalizzaEmail(form.getFieldValue('email')));
        setCorrezione(null);
        form.submit();
    };

    return (
        <div style={{ maxWidth: '400px', margin: '0 auto', paddingTop: '2rem' }}>
            <div className="dashboard-title">
                REGISTRA UN NUOVO UTENTE
            </div>
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Form.Item label="Nome" name="nome" rules={[{ required: true, message: 'Inserisci il nome' }]}>
                    <Input placeholder="Nome" />
                </Form.Item>
                <Form.Item label="Cognome" name="cognome" rules={[{ required: true, message: 'Inserisci il cognome' }]}>
                    <Input placeholder="Cognome" />
                </Form.Item>
                <Form.Item label="Email" name="email" rules={[{ required: true, type: 'email', message: 'Inserisci un email valida' }]}>
                    <Input placeholder="Email" />
                </Form.Item>
                <Form.Item
                    name="privacy"
                    valuePropName="checked"
                    rules={[{
                        validator: (_, valore) => (valore
                            ? Promise.resolve()
                            : Promise.reject(new Error('Serve il consenso privacy dell\'iscritto'))),
                    }]}
                >
                    <Checkbox>Ho raccolto il consenso privacy dell'iscritto</Checkbox>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Registra Utente
                    </Button>
                </Form.Item>
            </Form>

            <Modal
                title="Controlla l'indirizzo email"
                open={!!correzione}
                onOk={accettaCorrezione}
                onCancel={mantieniIndirizzo}
                okText="Sì, correggi"
                cancelText="No, è giusto così"
                getContainer={document.body}
                className="custom-modal"
            >
                <p>Forse intendevi <strong>{correzione}</strong>?</p>
                <p style={{ color: 'var(--testo-tenue)', marginBottom: 0 }}>
                    La password temporanea arriva per email: se l'indirizzo è sbagliato
                    l'utente non potrà accedere.
                </p>
            </Modal>
        </div>
    );
};

export default RegisterUser;
